// extracted by mini-css-extract-plugin
export default {"container":"InfoItemKeyValue_container__ItHZ-","key":"InfoItemKeyValue_key__Vfm8y","value":"InfoItemKeyValue_value__l+pb7","text":"InfoItemKeyValue_text__FKBng"};